<template>
	<p>
		©{{ year }} {{ company }} - {{ $t('Misc.VatShort') }} {{ vat }} -
		{{ $t('Misc.AllRightsReserved') }}
	</p>
</template>

<script>
import Config from '@/config'

export default {
	name: 'FooterCredits',
	computed: {
		company() {
			return Config.COMPANY_NAME
		},
		year() {
			return Config.COPYRIGHT_YEAR
		},
		vat() {
			return Config.COMPANY_VAT
		},
	},
}
</script>



// WEBPACK FOOTER //
// src/components/footer/FooterCredits.vue